import { createTheme } from '@mui/material/styles';
import { viVN } from '@mui/material/locale';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment-timezone';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import {
    Grid,
    Button,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    TextField,
    Typography,
    CircularProgress,
    InputAdornment,
    Card,
    CardActions,
    CardContent,
    Menu,
    Tooltip,
    IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SubCard from 'ui-component/cards/SubCard';
import StorageIcon from '@mui/icons-material/Storage';
import CodeIcon from '@mui/icons-material/Code';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import ApiIcon from '@mui/icons-material/Api';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SummarizeIcon from '@mui/icons-material/Summarize';
import useConfig from 'hooks/useConfig';
import { useDispatch, useSelector } from 'react-redux';
// import { useDispatch, useSelector } from 'store';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// project imports
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import { openSnackbar } from 'store/slices/snackbar';
// project imports
// assets
import 'react-lazy-load-image-component/src/effects/blur.css';
import ShareIcon from '@mui/icons-material/Share';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
//project imports
// import AWS from 'aws-sdk'; // REMOVED: No longer using AWS S3 SDK
import {
    fetchProjects,
    addProjects,
    createProjectJupyterhub,
    deleteProjectJupyterhub,
    setProjectsList
} from 'store/slices/project';
import apiSlice from 'store/slices/apiSlice';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { fetchVectors, fetchApiKeys, updateModel } from 'store/slices/vector';
import { insertSitemap } from 'store/slices/sitemap';
import { fetchUploadedFiles, removeUploadedFiles, setIsUploadedFiles } from 'store/slices/uploadedfile';
import {
    InsertLinkTwoTone,
    FilterList
} from '@mui/icons-material';
import { removeAccents, validateDataType } from 'utils/customized-functions';
import { canCreateProject, isSuperadmin, canManageProjectMembers } from 'utils/rbacUtils';
import { getUserContext, getEffectivePermissions, hasPermission } from 'utils/rbac';
import ProjectMembersDialog from './ProjectMembersDialog';
import TableUploadFile from './upload/TableUploadFile';
// import TableMongoDB from './mongodb/TableMongoDB'; // Moved to MongoDBModulePage
// import TableAirflow from './airflow/TableAirflow'; // Moved to AirflowModulePage
import Upload from './upload/Upload';
import AirflowLogo from '../../../assets/icons/airflow_logo.png';
import JupyterHubLogo from '../../../assets/icons/Jupyter_logo.svg.png';
import ApiGatewayLogo from '../../../assets/icons/api_gateway_logo.svg';
// import MuiFileManager from "mui-file-manager" // Commented out - package not properly built in v2
// import ProjectApiGateway from './apigateway/ProjectApiGateway' // Moved to ApiGatewayModulePage
import jupyterContainerService from '../../../services/jupyterContainerService';
// import CVModulePage from './cv/CVModulePage' // Moved to WorkspaceStorageRouter

// ==============================|| ANALYTICS DASHBOARD ||============================== //

// const API_URL = 'https://httpbin.org/post'
// const API_METHOD = 'POST'
const STATUS_IDLE = 0;
const STATUS_UPLOADING = 1;
// table columns
export const columns = [
    { field: 'id', headerName: 'STT', width: 70 },
    {
        field: 'name',
        headerName: 'Tên tài liệu',
        // description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 300
        // valueGetter: (params) => `${params.row.firstName || ''} ${params.row.lastName || ''}`
    },
    { field: 'type', headerName: 'Định dạng', width: 130 },
    { field: 'size', headerName: 'Dung lượng', width: 130 },
    {
        field: 'label',
        headerName: 'Nhãn',
        width: 90
    },
    {
        field: 'created_date',
        headerName: 'Thời gian',
        width: 300
    }
];

// table data
// export const rows = [
//     { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
//     { id: 2, lastName: 'Lancaster', firstName: 'Cersei', age: 42 },
//     { id: 3, lastName: 'Lancaster', firstName: 'Jaime', age: 45 },
//     { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
//     { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
//     { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
//     { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
//     { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
//     { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 }
// ];

const options = [
    { label: 'Tất cả thời gian', value: 'all' },
    { label: '7 ngày trước', value: '7' },
    { label: '30 ngày trước', value: '30' },
    { label: '90 ngày trước', value: '90' }
];

const sortOptions = [
    { label: 'Xếp theo mới nhất', value: 'newest' },
    { label: 'Xếp theo cũ nhất', value: 'oldest' }
];

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparator = (order, orderBy) =>
    order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const ProjectManagement = () => {
    const theme = useTheme();
    const locale = createTheme(
        {
            // palette: {
            //     primary: { main: '#1976d2' }
            // }
        },
        viVN
    );

    // Define handleDeleteClick function early to avoid scope issues
    const handleDeleteClick = async (FolderName) => {
        const project_name = FolderName.replace('/', '');
        const ownerToken = projectsState?.projects?.find((p) => (p.project_name || p.projectName) === project_name)?.user_token;
        const jupyterhub_username = ownerToken ? `${ownerToken}_${project_name}` : `${account?.user?.user_token || 'null'}_${project_name}`;
        try {
            await dispatch(apiSlice.endpoints.deleteProject.initiate(project_name)).unwrap();
            setOpenDelete(false);
            setFolderName('');
            // Cập nhật UI ngay: xóa project khỏi state.project (tránh race với GET list)
            const nextList = (projectsState?.projects || []).filter(
                (p) => (p.project_name || p.projectName || '').toLowerCase() !== project_name.toLowerCase()
            );
            dispatch(setProjectsList(nextList));
            // Không gọi fetchProjects() ở đây — UI đã cập nhật bằng setProjectsList; deleteProject mutation sẽ cập nhật cache RTK (tránh gọi list nhiều lần).
            dispatch(
                openSnackbar({
                    open: true,
                    anchorOrigin: { vertical: 'top', horizontal: 'center' },
                    message: 'Xóa dự án thành công',
                    variant: 'alert',
                    alert: { color: 'success' }
                })
            );
            dispatch(deleteProjectJupyterhub(jupyterhub_username));
        } catch (error) {
            console.error('Delete project error:', error);
            dispatch(
                openSnackbar({
                    open: true,
                    anchorOrigin: { vertical: 'top', horizontal: 'center' },
                    message: error?.data?.detail || 'Xóa dự án thất bại',
                    variant: 'alert',
                    alert: { color: 'error' }
                })
            );
        }
    };
    const cardStyle = {
        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : '#ffffff',
        border: 'none',
        borderRadius: '16px',
        minHeight: '100%',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: theme.palette.mode === 'dark' ? '0 12px 24px rgba(0,0,0,0.4)' : '0 12px 24px rgba(0,0,0,0.08)'
        }
    };
    const CardContentStyle = {
        padding: '24px',
        paddingLeft: '24px'
    };

    // const navRef = useRef(null);
    const apiHost = process.env.REACT_APP_API_URL;
    const embeddingsName = 'openai_text-embedding-ada-002';

    const S3_BUCKET = 'datahub.n2nai.io';
    const REGION = 'ap-southeast-1';
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const vectorsState = useSelector((state) => state.vector);
    const sitemapsState = useSelector((state) => state.sitemap);
    const projectsState = useSelector((state) => state.project);
    const uploadedFilesState = useSelector((state) => state.uploadedFile);
    const account = useSelector((state) => state.account);
    const canCreateProjectRole = canCreateProject(account?.user);
    const isSuperadminRole = isSuperadmin(account?.user);

    // REMOVED: AWS S3 configuration - now using backend API with GCS
    // AWS.config.update({
    //     accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    //     secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
    //     s3Url: 'http://datahub.n2nai.io.s3-website-ap-southeast-1.amazonaws.com',
    //     bucketName: S3_BUCKET,
    //     region: REGION
    // });

    // const s3 = new AWS.S3();
    let alertTimeout;
    //State for external Component
    const [initialProjectsState, setInitialProjectsState] = React.useState(true);
    const [files, setFiles] = React.useState([]);
    const [status, setStatus] = React.useState(STATUS_IDLE);
    const [project, setProject] = React.useState('document');
    const [projects, setProjects] = React.useState([]);

    //State for dispatch-redux
    const [vectors, setVectors] = React.useState([]);
    const [vector, setVector] = React.useState([]);
    const [apiKeys, setApiKeys] = React.useState([]);
    const [sitemap, setSitemap] = React.useState('');
    const [sitemaps, setSitemaps] = React.useState([]);
    const [urlitems, setUrlitems] = React.useState([]);
    const [apiName, setApiName] = React.useState('');

    // State for internal Component
    const [FolderName, setFolderName] = React.useState('');
    const [FolderDesc, setFolderDesc] = React.useState('');
    const [projectSubname, setProjectSubname] = React.useState('');
    const [subObjects, setSubObjects] = React.useState([]);
    const [Folders, setFolders] = React.useState([]);
    const [OriginalObjects, setOriginalObjects] = React.useState([]);
    const [Objects, setObjects] = React.useState([]);
    const [MongoDBObjects, setMongoDBObjects] = React.useState([]);
    const [Images, setImages] = React.useState([]);
    const [Image, setImage] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [openUpdate, setOpenUpdate] = React.useState(false);
    const [openDelete, setOpenDelete] = React.useState(false);
    const [openImage, setOpenImage] = React.useState(false);
    const [rows, setRows] = React.useState([]);
    const [pageRows, setPageRows] = React.useState([]);
    const [isLoading, setLoading] = React.useState(true);
    const [isLoadingFileUpload, setLoadingFileUpload] = React.useState(false);
    const [isLoadingUrlItem, setLoadingUrlItem] = React.useState(false);
    const [isLoadingTableMongoDB, setLoadingTableMongoDB] = React.useState(false);
    const [isLoadingTableAirflow, setLoadingTableAirflow] = React.useState(false);
    const [isLoadingApiGateway, setLoadingApiGateway] = React.useState(false);
    const [isNameProjectExists, setNameProjectExists] = React.useState(false);
    const [isRename, setRename] = React.useState(false);
    const [isMatchDelete, setMatchDelete] = React.useState(false);
    const [isOpenFolder, setOpenFolder] = React.useState(false);

    const prevFolders = React.useRef([]);
    const prevLoading = React.useRef(null);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isShowUploadFile, setShowUploadFile] = React.useState(false);
    // const [isShowPage, setShowPage] = React.useState(false); // Removed - MongoDB now uses routes
    // const [isShowPageAirflow, setShowPageAirflow] = React.useState(false); // Removed - Airflow now uses routes
    // const [isShowPageApiGateway, setShowPageApiGateway] = React.useState(false); // Removed - API Gateway now uses routes
    // const [isShowPageCV, setShowPageCV] = React.useState(false); // Removed - CV now uses routes
    const [timeRange, setTimeRange] = React.useState('all');
    const [sort, setSort] = React.useState('desc');
    const [search, setSearch] = React.useState('');
    const [openSetting, setOpenSetting] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [projectName, setProjectName] = React.useState('');
    const [sourceValueRadio, setSourceValueRaido] = React.useState('my-document');
    const [modalValueRadio, setModalValueRadio] = React.useState('gpt-4');
    const [referenceValueRadio, setReferenceValueRadio] = React.useState('reference');
    const [temperatureParam, setTemperatureParam] = React.useState(1);
    const [kParam, setKParam] = React.useState(2);
    const [isOpenAddProject, setOpenAddProject] = React.useState(false);
    const [tenantAdminEmail, setTenantAdminEmail] = React.useState('');
    const [tenantAdminPassword, setTenantAdminPassword] = React.useState('');
    const [membersDialogProject, setMembersDialogProject] = React.useState(null);
    const [isCopy, setCopy] = React.useState(false);
    const [isCopyAPI, setCopyAPI] = React.useState(false);
    const [isCopyMongoDBUri, setCopyMongoDBUri] = React.useState(false);
    const [isCopyJupyterHubUser, setCopyJupyterHubUser] = React.useState(false);
    const [isCopyJupyterHubPasswd, setCopyJupyterHubPasswd] = React.useState(false);
    const [isCopyJupyterHubLink, setCopyJupyterHubLink] = React.useState(false);
    const [isCopyAirflowLink, setCopyAirflowLink] = React.useState(false);
    const [isCopyAirflowUser, setCopyAirflowUser] = React.useState(false);
    const [isCopyAirflowPasswd, setCopyAirflowPasswd] = React.useState(false);
    const { borderRadius } = useConfig();
    const [value, setValue] = React.useState('1');
    const [uploadModalState, setUploadModalState] = React.useState('INACTIVE');
    const [progress, setProgress] = React.useState();
    const [isAddSitemap, setAddSitemap] = React.useState(false);
    const [isOpenMongoDBInfo, setOpenMongoDBInfo] = React.useState(false);
    const [isOpenJupyterHubInfo, setOpenJupyterHubInfo] = React.useState(false);
    const [isOpenAirflowInfo, setOpenAirflowInfo] = React.useState(false);
    const [mongoDBUri, setMongoDBUri] = React.useState('');
    const [jupyterHubUser, setJupyterHubUser] = React.useState('');
    const [jupyterHubPasswd, setJupyterHubPasswd] = React.useState('');
    const [airflowUser, setAirflowUser] = React.useState('');
    const [airflowPasswd, setAirflowPasswd] = React.useState('');
    const [jupyterLabLoading, setJupyterLabLoading] = React.useState(null);
    const [jupyterLabLoadingMessage, setJupyterLabLoadingMessage] = React.useState('');
    const [biLoadingProject, setBiLoadingProject] = React.useState(null);
    const [jupyterHubLink, setJupyterHubLink] = React.useState('');
    const [airflowLink, setAirflowLink] = React.useState('');

    //State for time
    const [anchorElTimeRange, setanchorElTimeRange] = React.useState(null);
    const openSortTimeRange = Boolean(anchorElTimeRange);
    const [anchorElTimeSort, setanchorElTimeSort] = React.useState(null);
    const openSortTimeSort = Boolean(anchorElTimeSort);

    //State for button when content change and not change
    const [buttonConversationDisabled, setButtonConversationDisabled] = React.useState(true);
    const [buttonCreateProjectDisabled, setButtonCreateProjectDisabled] = React.useState(false);

    const [currentPath, setCurrentPath] = React.useState('/');

    // RBAC: quyền truy cập module Tổng hợp & Hỏi đáp tài liệu nghiên cứu
    const canAccessResearchDocs = React.useMemo(() => {
        const { user_roles = [], user_permissions = [] } = getUserContext();
        const hasRbacData = (user_roles && user_roles.length > 0) || (user_permissions && user_permissions.length > 0);
        if (!hasRbacData) return true;
        const effective = getEffectivePermissions(user_roles, user_permissions);
        return hasPermission(effective, 'research_docs', 'read');
    }, []);

    const initialState = {
        sort: 'newest',
        range: 'all'
    };
    const [filter, setFilter] = React.useState(initialState);

    useEffect(() => {
        setVector(vectorsState?.vectors.id);
        setVectors(vectorsState?.vectors);
        setApiKeys(vectorsState?.apikeys);
        setModalValueRadio(vectorsState?.vectors.model);
        setKParam(vectorsState?.vectors.top_k_docs);
        setTemperatureParam(vectorsState?.vectors.temperature);
    }, [vectorsState?.vectors.id, vectorsState?.apikeys]);

    useEffect(() => {
        if (FolderName != '' && openSetting && sitemapsState.sitemaps !== null) {
            setSitemaps(sitemapsState?.sitemaps);
        }
    }, [openSetting, FolderName, sitemapsState]);

    // NOTE: This effect was using setShowPage(true) which is removed after routing refactor
    // Uncomment if urlitems loading still needs special handling
    // useEffect(() => {
    //     if (FolderName != '' && isLoadingUrlItem && sitemapsState.urlitems !== null) {
    //         setUrlitems(sitemapsState?.urlitems);
    //         // setShowPage(true); // Removed - MongoDB now uses routes
    //         setLoadingUrlItem(false);
    //     }
    // }, [isLoadingUrlItem, FolderName, sitemapsState]);

    useEffect(() => {
        dispatch(fetchProjects());
        setInitialProjectsState(false);
    }, [project]);

    useEffect(() => {
        // if (!initialProjectsState) {
        setObjects(projectsState?.projects);
        setMongoDBObjects(projectsState?.tables);
        // console.log('projectsState',projectsState)
        // fetchFolders(project); // REMOVED: No longer using S3 for folder listing
        // console.log(projectsState?.projects);
        // }
    }, [projectsState]);

    useEffect(() => {
        if (uploadedFilesState?.uploadedFile) {
            setRows(uploadedFilesState.uploadedFile);
            // fetchFolders(project); // REMOVED: No longer using S3 for folder listing
            fetchFiles(project, FolderName, 'SETTING INSIDE');
            dispatch(setIsUploadedFiles(false));
        }

        // console.log(uploadedFilesState?.uploadedFile)
    }, [uploadedFilesState?.uploadedFile]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, [isShowUploadFile, openSetting]); // Removed isShowPage - modules now use routes

    // const handleClose = () => {
    //     setAnchorEl(null);
    // };
    // React.useEffect(() => {
    //     prevFolders.current = Folders;
    //     prevLoading.current = isLoading;
    // }, [Folders, isLoading]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setSelectedIndex(0);
    };

    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
    };

    const handleSearch = (event) => {
        const newString = event.target.value;

        setSearch(newString || '');
        if (newString) {
            const newObjects = Objects.filter((project) => {
                let matches = true;

                const properties = ['project_name', 'project_desc', 'created_date'];
                let containsQuery = false;

                properties.forEach((property) => {
                    const formattedPropterty = removeAccents(project[property].toString().toLowerCase());
                    const formattedNewString = removeAccents(newString.toString().toLowerCase());

                    if (formattedPropterty.includes(formattedNewString)) {
                        containsQuery = true;
                    }
                });

                if (!containsQuery) {
                    matches = false;
                }
                return matches;
            });
            setObjects(newObjects);
        } else {
            setObjects(projectsState?.projects);
        }
    };

    const handleClickListTimeRangeItem = (event) => {
        setanchorElTimeRange(event.currentTarget);
    };

    const handleClickListTimeSortItem = (event) => {
        setanchorElTimeSort(event.currentTarget);
    };

    const handleCloseTimeRange = () => {
        setanchorElTimeRange(null);
    };

    const handleCloseTimeSort = () => {
        setanchorElTimeSort(null);
    };

    const handleMenuTimeSortItemClick = (event, index) => {
        setFilter({ ...filter, sort: index });
        setanchorElTimeSort(null);

        switch (index) {
            case 'newest':
                sortProjectsByDate('desc');
                break;
            case 'oldest':
                sortProjectsByDate('asc');
                break;
            default:
                break;
        }
    };

    const sortProjectsByDate = (order) => {
        const sortedProjects = [...Objects].sort((a, b) => {
            const dateA = new Date(moment(a.created_date, "'DD/MM/YYYY hh:mm:ss'"));
            const dateB = new Date(moment(b.created_date, "'DD/MM/YYYY hh:mm:ss'"));

            if (order === 'desc') {
                return dateB - dateA;
            } else {
                return dateA - dateB;
            }
        });

        setObjects(sortedProjects);
    };

    useEffect(() => {
        // Check if projects exists and is an array
        if (!projectsState.projects || !Array.isArray(projectsState.projects)) {
            console.warn('Projects not loaded or not an array:', projectsState.projects);
            setObjects([]);
            return;
        }

        const sortedProjects = [...projectsState.projects].sort((a, b) => {
            const dateA = new Date(moment(a.created_date, "'DD/MM/YYYY hh:mm:ss'"));
            const dateB = new Date(moment(b.created_date, "'DD/MM/YYYY hh:mm:ss'"));
            return dateB - dateA;
        });
        setObjects(sortedProjects);
    }, [projectsState.projects]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'projectName') {
            setProjectName(value);
        }
    };

    // const uploadFiles = async (data) => {
    //     setStatus(STATUS_UPLOADING);

    //     // console.log(URL.createObjectURL(chosenFile[0]))

    //     await new Promise(async (resolve) => {
    //         await data.forEach(async (file, index, array) => {
    //             const params = {
    //                 Bucket: 'kmou-dp',
    //                 Key: 'Marine-Parts/' + project + '/' + FolderName + file['name'],
    //                 Body: file
    //             };

    //             s3.upload(params, function (err, data) {
    //                 if (err) console.log(err, err.stack); // an error occurred
    //                 else {
    //                     console.log('Success'); // successful response
    //                     if (String(index.split('-')[1]) === String(files.length - 1)) {
    //                         resolve('Uploaded File !');
    //                     }
    //                 }
    //             });
    //         });
    //     }).then((result) => {
    //         console.log(result);
    //         dispatch(
    //             openSnackbar({
    //                 open: true,
    //                 message: 'Upload - Success',
    //                 variant: 'alert',
    //                 alert: {
    //                     color: 'success'
    //                 },
    //                 close: false
    //             })
    //         );

    //         setFiles([]);
    //         setStatus(STATUS_IDLE);
    //     });

    //     // fetch(API_URL, {
    //     //     method: API_METHOD,
    //     //     body: data,
    //     // })
    //     // .then((res) => res.json())
    //     // .then((data) => console.log(data))
    //     // .catch((err) => console.error(err))
    //     // .finally(() => setStatus(STATUS_IDLE))
    // };

    const packFiles = async (files) => {
        const data = new FormData();

        [...files].forEach((file, i) => {
            data.append(`file-${i}`, file, file.name);
        });
        return data;
    };

    // const handleUploadClick = async () => {
    //     // console.log(files.length)
    //     if (files.length) {
    //         const data = await packFiles(files);
    //         uploadFiles(data);
    //     }
    // };

    // var expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
    // var regex = new RegExp(expression);

    const handleModelSubmit = async () => {
        if (
            !validateDataType(temperatureParam, 'float') ||
            (validateDataType(temperatureParam, 'float') && (temperatureParam < 0 || temperatureParam > 2)) ||
            !validateDataType(kParam, 'int') ||
            (validateDataType(kParam, 'int') && kParam < 0)
        ) {
            dispatch(
                openSnackbar({
                    open: true,
                    anchorOrigin: { vertical: 'top', horizontal: 'center' },
                    message: 'Vui lòng kiểm tra lại dữ liệu!',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                })
            );
            return;
        }

        try {
            const result = await dispatch(
                updateModel(FolderName.replaceAll('/', ''), vector, project, modalValueRadio, temperatureParam, kParam)
            );
            dispatch(
                openSnackbar({
                    open: true,
                    anchorOrigin: { vertical: 'top', horizontal: 'center' },
                    message: 'Cập nhật Model thành công',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                })
            );
            setButtonConversationDisabled(true);
        } catch (error) {
            dispatch(
                openSnackbar({
                    open: true,
                    anchorOrigin: { vertical: 'top', horizontal: 'center' },
                    message: 'Đã có lỗi xảy ra. Vui lòng thử lại sau!',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                })
            );
        }
    };

    const handleAddSiteMap = () => {
        let sitemap_ = '';
        if (sitemap === '') {
            alert('Vui lòng điền sitemap');
        }
        // else if (!sitemap.match(regex)) {
        // alert('Vui lòng điền sitemap hợp lệ! \nVí dụ: \n - http://abc.xyz.vn \n - https://abc.xyz.vn \n - abc.xyz.vn');
        // }
        else {
            sitemap_ = sitemap;
            if (sitemap.indexOf('http') === -1) {
                sitemap_ = 'http://' + sitemap;
            }
            dispatch(insertSitemap(project, FolderName, vector, sitemap_));
            setSitemap('');
            dispatch(
                openSnackbar({
                    open: true,
                    anchorOrigin: { vertical: 'top', horizontal: 'center' },
                    message: 'Thêm mới sitemap thành công, hệ thống đang xử lý crawl dữ liệu. Ước tính xử lý từ 10 đến 15 phút',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                })
            );
            setAddSitemap(false);
        }
    };

    //download QR Code
    const downloadQR = () => {
        const canvas = document.getElementById('qrcode');
        const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
        let downloadLink = document.createElement('a');
        downloadLink.href = pngUrl;
        downloadLink.download = 'youteach-qrcode-sharebot.png';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    const renderFileList = () => {
        // return <ol>
        //     {[...Objects].map((f, i) => {
        //         console.log(f)
        //         return <li key={i}>{f}</li>
        //     })}
        // </ol>
        return (
            <MainCard
                title={
                    <Grid
                        container
                        alignItems="center"
                        // justifyContent="space-between"
                        spacing={gridSpacing}
                    >
                        <Grid item>
                            <Button
                                variant=""
                                style={{
                                    color: 'white',
                                    backgroundColor: 'grey'
                                }}
                                onClick={() => {
                                    setOpen(false);
                                }}
                            >
                                Quay lại
                            </Button>
                        </Grid>
                        <Grid item>
                            <Typography variant="h3">{FolderName}</Typography>
                        </Grid>
                        {/* <Grid item>
                    <OutlinedInput
                        id="input-search-card-style1"
                        placeholder="Search"
                        startAdornment={
                            <InputAdornment position="start">
                                <IconSearch stroke={1.5} size="16px" />
                            </InputAdornment>
                        }
                        size="small"
                    />
                </Grid> */}
                    </Grid>
                }
            >
                <Box
                    sx={{
                        height: 400,
                        width: '100%',
                        '& .MuiDataGrid-root': {
                            border: 'none',
                            '& .MuiDataGrid-cell': {
                                borderColor: theme.palette.mode === 'dark' ? theme.palette.text.primary + 15 : 'grey.200'
                            },
                            '& .MuiDataGrid-columnsContainer': {
                                color: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.900',
                                borderColor: theme.palette.mode === 'dark' ? theme.palette.text.primary + 15 : 'grey.200'
                            },
                            '& .MuiDataGrid-columnSeparator': {
                                color: theme.palette.mode === 'dark' ? theme.palette.text.primary + 15 : 'grey.200'
                            }
                        }
                    }}
                >
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        // onSelectionModelChange={(newSelectionModel) => {
                        //     const selectedIDs = new Set(newSelectionModel);
                        //     const selectedRowData = rows.filter((row) => selectedIDs.has(row.id));
                        //     Selected(selectedRowData);
                        // }}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        checkboxSelection
                    />
                </Box>
            </MainCard>
        );
    };

    const renderProjectList = (projects) =>
        [...projects].map((f, i) => {
            return (
                <Box key={i} sx={{ mb: 3 }}>
                    <SubCard
                        title={
                            <Stack>
                                <Typography variant="h3">{f.project_name}</Typography>
                                <Typography variant="body1" color="text.secondary">{f.project_desc}</Typography>
                            </Stack>
                        }
                        secondary={
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5, flexWrap: 'wrap' }}>
                                <Typography variant="body2" color="text.secondary">
                                    Ngày tạo: {moment(f.created_date, "'YYYY-MM-DD hh:mm:ss'").format('DD/MM/YYYY')}
                                </Typography>
                                <Tooltip title="Cài đặt dự án">
                                    <IconButton
                                        size="small"
                                        onClick={async () => {
                                            setOpenSetting(true);
                                            setValue('1');
                                            setSelectedIndex(0);
                                            setFolderName(f.project_name + '/');
                                            setProjectSubname(f.project_subname);
                                            dispatch(fetchApiKeys(f.project_name));
                                            dispatch(fetchUploadedFiles(f.project_name));
                                        }}
                                    >
                                        <SettingsIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                {canManageProjectMembers(f, account?.user) && (
                                    <Tooltip title="Thành viên project">
                                        <IconButton size="small" onClick={() => setMembersDialogProject(f.project_name)}>
                                            <PeopleIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                <Tooltip title="Chia sẻ dự án">
                                    <IconButton
                                        size="small"
                                        onClick={() => {
                                            setOpenSetting(true);
                                            setSelectedIndex(0);
                                            setValue('4');
                                            setFolderName(f.project_name + '/');
                                            setProjectSubname(f.project_subname);
                                            dispatch(fetchVectors(f.project_name + '/'));
                                            dispatch(fetchApiKeys(f.project_name));
                                            setVector(vectorsState?.vectors.id);
                                        }}
                                    >
                                        <ShareIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Xóa dự án">
                                    <IconButton
                                        size="small"
                                        onClick={() => {
                                            setFolderName(f.project_name + '/');
                                            handleClickOpenDelete();
                                        }}
                                    >
                                        <DeleteOutlineIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        }
                        sx={{ mt: gridSpacing }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 1 }}>
                                {/* Nhánh 1: Vào Storage (File) – quản lý file theo project */}
                                <Box sx={{ minWidth: 260, flex: '1 1 260px' }}>
                                    <Card
                                        sx={{
                                            ...cardStyle,
                                            boxShadow: '0 4px 12px rgba(33,150,243,0.15)',
                                            borderLeft: '4px solid #2196F3'
                                        }}
                                    >
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Stack direction="row" alignItems="center" spacing={1.5}>
                                                        <Box
                                                            sx={{
                                                                width: 48,
                                                                height: 48,
                                                                borderRadius: '12px',
                                                                background: 'linear-gradient(135deg, #2196F3 0%, #42A5F5 100%)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: '0 4px 8px rgba(33,150,243,0.25)'
                                                            }}
                                                        >
                                                            <StorageIcon sx={{ color: '#fff', fontSize: 28 }} />
                                                        </Box>
                                                        <Box>
                                                            <Typography
                                                                variant="body2"
                                                                color="text.secondary"
                                                                sx={{ fontWeight: 500, mb: 0.5 }}
                                                            >
                                                                Storage (File)
                                                            </Typography>
                                                            <Typography variant="h2" sx={{ fontWeight: 700, color: '#2196F3' }}>
                                                                File
                                                            </Typography>
                                                        </Box>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={{ ...CardContentStyle, paddingTop: 0 }}>
                                            <Button
                                                variant="contained"
                                                sx={{ bgcolor: '#2196F3' }}
                                                onClick={() => {
                                                    navigate('/storage/files', { state: { projectId: f.project_name } });
                                                }}
                                            >
                                                Vào Storage
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Box>
                                {/* Nhánh 2: Big Data / Lakehouse */}
                                <Box sx={{ minWidth: 260, flex: '1 1 260px' }}>
                                    <Card
                                        sx={{
                                            ...cardStyle,
                                            boxShadow: '0 4px 12px rgba(0,188,212,0.15)',
                                            borderLeft: '4px solid #00BCD4'
                                        }}
                                    >
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Stack direction="row" alignItems="center" spacing={1.5}>
                                                        <Box
                                                            sx={{
                                                                width: 48,
                                                                height: 48,
                                                                borderRadius: '12px',
                                                                background: 'linear-gradient(135deg, #00BCD4 0%, #4DD0E1 100%)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: '0 4px 8px rgba(0,188,212,0.25)'
                                                            }}
                                                        >
                                                            <StorageIcon sx={{ color: '#fff', fontSize: 28 }} />
                                                        </Box>
                                                        <Box>
                                                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, mb: 0.5 }}>
                                                                Big Data / Lakehouse
                                                            </Typography>
                                                            <Typography variant="h2" sx={{ fontWeight: 700, color: '#00BCD4' }}>
                                                                Data Sources
                                                            </Typography>
                                                        </Box>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={{ ...CardContentStyle, paddingTop: 0 }}>
                                            <Button
                                                variant="contained"
                                                sx={{ bgcolor: '#00BCD4' }}
                                                onClick={() =>
                                                    navigate(
                                                        `/workspace/storage/${f.project_name}/lakehouse?subname=${encodeURIComponent(f.project_subname)}`
                                                    )
                                                }
                                            >
                                                Quản lý 4 nguồn DB
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Box>
                                <Box sx={{ minWidth: 260, flex: '1 1 260px' }}>
                                    <Card
                                        sx={{
                                            ...cardStyle,
                                            boxShadow: '0 4px 12px rgba(216,67,21,0.15)',
                                            borderLeft: '4px solid #D84315'
                                        }}
                                    >
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Stack direction="row" alignItems="center" spacing={1.5}>
                                                        <Box
                                                            sx={{
                                                                width: 48,
                                                                height: 48,
                                                                borderRadius: '12px',
                                                                background: 'linear-gradient(135deg, #D84315 0%, #FF6F40 100%)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: '0 4px 8px rgba(216,67,21,0.25)'
                                                            }}
                                                        >
                                                            <CodeIcon sx={{ color: '#fff', fontSize: 28 }} />
                                                        </Box>
                                                        <Box>
                                                            <Typography
                                                                variant="body2"
                                                                color="text.secondary"
                                                                sx={{ fontWeight: 500, mb: 0.5 }}
                                                            >
                                                                Jupyter Hub
                                                            </Typography>
                                                            <Typography variant="h2" sx={{ fontWeight: 700, color: '#D84315' }}>
                                                                Lab
                                                            </Typography>
                                                        </Box>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={{ ...CardContentStyle, paddingTop: 0 }}>
                                            <Button
                                                variant="contained"
                                                color="error"
                                                fullWidth
                                                disabled={jupyterLabLoading === f.id}
                                                onClick={async () => {
                                                    try {
                                                        setJupyterLabLoading(f.id);
                                                        setJupyterLabLoadingMessage('Đang kết nối...');

                                                        await jupyterContainerService.openInNewTab(f.id, (message) => {
                                                            setJupyterLabLoadingMessage(message || 'Đang khởi động...');
                                                            dispatch(
                                                                openSnackbar({
                                                                    open: true,
                                                                    message: message,
                                                                    variant: 'alert',
                                                                    alert: { color: 'info' },
                                                                    close: false,
                                                                    autoHideDuration: 2000
                                                                })
                                                            );
                                                        });

                                                        dispatch(
                                                            openSnackbar({
                                                                open: true,
                                                                message: 'JupyterLab đã sẵn sàng!',
                                                                variant: 'alert',
                                                                alert: { color: 'success' },
                                                                close: true
                                                            })
                                                        );
                                                    } catch (error) {
                                                        console.error('Error opening JupyterLab:', error);
                                                        dispatch(
                                                            openSnackbar({
                                                                open: true,
                                                                message: 'Không thể khởi động JupyterLab. Vui lòng thử lại.',
                                                                variant: 'alert',
                                                                alert: { color: 'error' },
                                                                close: true
                                                            })
                                                        );
                                                    } finally {
                                                        setJupyterLabLoading(null);
                                                        setJupyterLabLoadingMessage('');
                                                    }
                                                }}
                                            >
                                                {jupyterLabLoading === f.id ? (
                                                    <>
                                                        <CircularProgress size={20} sx={{ color: 'white', marginRight: 1 }} />
                                                        {jupyterLabLoadingMessage || 'Đang khởi động...'}
                                                    </>
                                                ) : (
                                                    <>
                                                        <img src={JupyterHubLogo} style={{ width: 40, height: 40, marginRight: 8 }} />
                                                        Mở Lab
                                                    </>
                                                )}
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Box>
                                <Box sx={{ minWidth: 260, flex: '1 1 260px' }}>
                                    <Card
                                        sx={{
                                            ...cardStyle,
                                            boxShadow: '0 4px 12px rgba(2,136,209,0.15)',
                                            borderLeft: '4px solid #0288d1'
                                        }}
                                    >
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Stack direction="row" alignItems="center" spacing={1.5}>
                                                        <Box
                                                            sx={{
                                                                width: 48,
                                                                height: 48,
                                                                borderRadius: '12px',
                                                                background: 'linear-gradient(135deg, #0288d1 0%, #29B6F6 100%)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: '0 4px 8px rgba(2,136,209,0.25)'
                                                            }}
                                                        >
                                                            <CloudQueueIcon sx={{ color: '#fff', fontSize: 28 }} />
                                                        </Box>
                                                        <Box>
                                                            <Typography
                                                                variant="body2"
                                                                color="text.secondary"
                                                                sx={{ fontWeight: 500, mb: 0.5 }}
                                                            >
                                                                Apache Airflow
                                                            </Typography>
                                                            <Typography variant="h2" sx={{ fontWeight: 700, color: '#0288d1' }}>
                                                                DAG
                                                            </Typography>
                                                        </Box>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={{ ...CardContentStyle, paddingTop: 0 }}>
                                            <Button
                                                variant="outlined"
                                                color="info"
                                                onClick={() => {
                                                    navigate(
                                                        `/workspace/storage/${f.project_name}/airflow?subname=${encodeURIComponent(f.project_subname)}`
                                                    );
                                                }}
                                            >
                                                <img
                                                    src={AirflowLogo}
                                                    style={{ width: 50, height: 50, justifyItems: 'center' }}
                                                    stroke={1.5}
                                                />
                                            </Button>
                                            <Button
                                                variant="text"
                                                color="info"
                                                onClick={() => {
                                                    setOpenAirflowInfo(true);
                                                    setAirflowLink(f.airflow_link);
                                                    setAirflowUser(f.user_airflow);
                                                    setAirflowPasswd(f.passwd_airflow);
                                                }}
                                            >
                                                Thông tin kết nối
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Box>
                                <Box sx={{ minWidth: 260, flex: '1 1 260px' }}>
                                    <Card
                                        sx={{
                                            ...cardStyle,
                                            boxShadow: '0 4px 12px rgba(156,39,176,0.15)',
                                            borderLeft: '4px solid #9C27B0'
                                        }}
                                    >
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Stack direction="row" alignItems="center" spacing={1.5}>
                                                        <Box
                                                            sx={{
                                                                width: 48,
                                                                height: 48,
                                                                borderRadius: '12px',
                                                                background: 'linear-gradient(135deg, #9C27B0 0%, #BA68C8 100%)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: '0 4px 8px rgba(156,39,176,0.25)'
                                                            }}
                                                        >
                                                            <SummarizeIcon sx={{ color: '#fff', fontSize: 28 }} />
                                                        </Box>
                                                        <Box>
                                                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, mb: 0.5 }}>
                                                                BI (Superset)
                                                            </Typography>
                                                            <Typography variant="h2" sx={{ fontWeight: 700, color: '#9C27B0' }}>
                                                                Báo cáo
                                                            </Typography>
                                                        </Box>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={{ ...CardContentStyle, paddingTop: 0 }}>
                                            <Button
                                                variant="contained"
                                                sx={{ bgcolor: '#9C27B0' }}
                                                disabled={biLoadingProject === f.project_name}
                                                onClick={async () => {
                                                    try {
                                                        setBiLoadingProject(f.project_name);
                                                        const result = await dispatch(
                                                            apiSlice.endpoints.getBiAccess.initiate(f.project_name)
                                                        ).unwrap();
                                                        const url = result?.url ?? result?.data?.url;
                                                        if (url) {
                                                            window.open(url, '_blank', 'noopener,noreferrer');
                                                            dispatch(openSnackbar({ open: true, message: 'Đã mở Superset.', variant: 'alert', alert: { color: 'success' }, close: true }));
                                                        }
                                                    } catch (e) {
                                                        dispatch(openSnackbar({ open: true, message: 'Không thể mở BI. Kiểm tra quyền project.', variant: 'alert', alert: { color: 'error' }, close: true }));
                                                    } finally {
                                                        setBiLoadingProject(null);
                                                    }
                                                }}
                                            >
                                                {biLoadingProject === f.project_name ? (
                                                    <CircularProgress size={20} sx={{ color: 'white', marginRight: 1 }} />
                                                ) : null}
                                                Mở BI
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Box>
                                <Box sx={{ minWidth: 260, flex: '1 1 260px' }}>
                                    <Card
                                        sx={{
                                            ...cardStyle,
                                            boxShadow: '0 4px 12px rgba(229,57,53,0.15)',
                                            borderLeft: '4px solid #E53935'
                                        }}
                                    >
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Stack direction="row" alignItems="center" spacing={1.5}>
                                                        <Box
                                                            sx={{
                                                                width: 48,
                                                                height: 48,
                                                                borderRadius: '12px',
                                                                background: 'linear-gradient(135deg, #E53935 0%, #EF5350 100%)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: '0 4px 8px rgba(229,57,53,0.25)'
                                                            }}
                                                        >
                                                            <ApiIcon sx={{ color: '#fff', fontSize: 28 }} />
                                                        </Box>
                                                        <Box>
                                                            <Typography
                                                                variant="body2"
                                                                color="text.secondary"
                                                                sx={{ fontWeight: 500, mb: 0.5 }}
                                                            >
                                                                API Gateway
                                                            </Typography>
                                                            <Typography variant="h2" sx={{ fontWeight: 700, color: '#E53935' }}>
                                                                Deploy API
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
                                                                Cung cấp API cho bên ngoài từ Storage, Lakehouse, CV, Jupyter, Airflow, RAG
                                                            </Typography>
                                                        </Box>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={{ ...CardContentStyle, paddingTop: 0 }}>
                                            <Button
                                                variant="outlined"
                                                sx={{
                                                    color: '#E53935',
                                                    borderColor: '#E53935',
                                                    '&:hover': {
                                                        backgroundColor: '#E5393520',
                                                        borderColor: '#E53935'
                                                    }
                                                }}
                                                onClick={() => {
                                                    navigate(
                                                        `/workspace/storage/${f.project_name}/api-gateway?subname=${encodeURIComponent(f.project_subname)}`
                                                    );
                                                }}
                                            >
                                                <img
                                                    src={ApiGatewayLogo}
                                                    style={{ width: 50, height: 50, justifyItems: 'center' }}
                                                    stroke={1.5}
                                                />
                                            </Button>
                                            <Button
                                                variant="text"
                                                sx={{ color: '#E53935' }}
                                                onClick={() => {
                                                    navigate(
                                                        `/workspace/storage/${f.project_name}/api-gateway?subname=${encodeURIComponent(f.project_subname)}`
                                                    );
                                                }}
                                            >
                                                Quản lý API Keys
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Box>
                                {/* Publish — Data Product Hub (Phase 1 2026-05-21) */}
                                <Box sx={{ minWidth: 260, flex: '1 1 260px' }}>
                                    <Card sx={{
                                        ...cardStyle,
                                        boxShadow: '0 4px 12px rgba(156,39,176,0.15)',
                                        borderLeft: '4px solid #9C27B0'
                                    }}>
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Stack direction="row" alignItems="center" spacing={1.5}>
                                                        <Box sx={{
                                                            width: 48, height: 48, borderRadius: '12px',
                                                            background: 'linear-gradient(135deg, #9C27B0 0%, #BA68C8 100%)',
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            boxShadow: '0 4px 8px rgba(156,39,176,0.25)',
                                                            fontSize: 22, color: '#fff', fontWeight: 700
                                                        }}>📦</Box>
                                                        <Box>
                                                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, mb: 0.5 }}>
                                                                Data Product Hub
                                                            </Typography>
                                                            <Typography variant="h2" sx={{ fontWeight: 700, color: '#9C27B0' }}>
                                                                Publish
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
                                                                Publish final tables / use cases ra catalog Colab cho external researcher consume
                                                            </Typography>
                                                        </Box>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={{ ...CardContentStyle, paddingTop: 0 }}>
                                            <Button
                                                variant="outlined"
                                                sx={{ color: '#9C27B0', borderColor: '#9C27B0',
                                                      '&:hover': { backgroundColor: '#9C27B020', borderColor: '#9C27B0' } }}
                                                onClick={() => navigate(`/workspace/storage/${f.project_name}/publish`)}
                                            >
                                                Quản lý products
                                            </Button>
                                            <Button
                                                variant="text"
                                                sx={{ color: '#9C27B0' }}
                                                href="/catalog"
                                                target="_blank"
                                            >
                                                Xem catalog ↗
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Box>
                                <Box sx={{ minWidth: 260, flex: '1 1 260px' }}>
                                    <Card
                                        sx={{
                                            ...cardStyle,
                                            boxShadow: '0 4px 12px rgba(76,175,80,0.15)',
                                            borderLeft: '4px solid #4CAF50'
                                        }}
                                    >
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Stack direction="row" alignItems="center" spacing={1.5}>
                                                        <Box
                                                            sx={{
                                                                width: 48,
                                                                height: 48,
                                                                borderRadius: '12px',
                                                                background: 'linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: '0 4px 8px rgba(76,175,80,0.25)'
                                                            }}
                                                        >
                                                            <PhotoCameraIcon sx={{ color: '#fff', fontSize: 28 }} />
                                                        </Box>
                                                        <Box>
                                                            <Typography
                                                                variant="body2"
                                                                color="text.secondary"
                                                                sx={{ fontWeight: 500, mb: 0.5 }}
                                                            >
                                                                AI Computer Vision
                                                            </Typography>
                                                            <Typography variant="h2" sx={{ fontWeight: 700, color: '#4CAF50' }}>
                                                                Models
                                                            </Typography>
                                                        </Box>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={{ ...CardContentStyle, paddingTop: 0 }}>
                                            <Button
                                                variant="outlined"
                                                sx={{
                                                    color: '#4CAF50',
                                                    borderColor: '#4CAF50',
                                                    '&:hover': {
                                                        backgroundColor: '#4CAF5020',
                                                        borderColor: '#4CAF50'
                                                    }
                                                }}
                                                onClick={() => {
                                                    navigate(
                                                        `/workspace/storage/${f.project_name}/cv?subname=${encodeURIComponent(f.project_subname)}`
                                                    );
                                                }}
                                            >
                                                <SmartToyIcon sx={{ fontSize: 28 }} />
                                            </Button>
                                            <Button
                                                variant="text"
                                                sx={{ color: '#4CAF50' }}
                                                onClick={() => {
                                                    navigate(
                                                        `/workspace/storage/${f.project_name}/cv?subname=${encodeURIComponent(f.project_subname)}`
                                                    );
                                                }}
                                            >
                                                Quản lý AI Models
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Box>
                                {/* Nhánh: Tổng hợp & Hỏi đáp tài liệu nghiên cứu (RAG) – RBAC: research_docs:read */}
                                {canAccessResearchDocs && (
                                <Box sx={{ minWidth: 260, flex: '1 1 260px' }}>
                                    <Card
                                        sx={{
                                            ...cardStyle,
                                            boxShadow: '0 4px 12px rgba(102,187,106,0.15)',
                                            borderLeft: '4px solid #66BB6A'
                                        }}
                                    >
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Stack direction="row" alignItems="center" spacing={1.5}>
                                                        <Box
                                                            sx={{
                                                                width: 48,
                                                                height: 48,
                                                                borderRadius: '12px',
                                                                background: 'linear-gradient(135deg, #66BB6A 0%, #81C784 100%)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: '0 4px 8px rgba(102,187,106,0.25)'
                                                            }}
                                                        >
                                                            <SummarizeIcon sx={{ color: '#fff', fontSize: 28 }} />
                                                        </Box>
                                                        <Box>
                                                            <Typography
                                                                variant="body2"
                                                                color="text.secondary"
                                                                sx={{ fontWeight: 500, mb: 0.5 }}
                                                            >
                                                                Tổng hợp & Hỏi đáp tài liệu nghiên cứu
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
                                                                Nhập tài liệu nghiên cứu, đặt câu hỏi và nhận câu trả lời tổng hợp từ RAG
                                                            </Typography>
                                                        </Box>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={{ ...CardContentStyle, paddingTop: 0 }}>
                                            <Button
                                                variant="contained"
                                                href={f.project_name ? `/workspace/document?id=${encodeURIComponent(f.project_name)}` : undefined}
                                                disabled={!f.project_name}
                                                sx={{ bgcolor: '#66BB6A', '&:hover': { bgcolor: '#558B2F' } }}
                                            >
                                                Vào Hỏi đáp
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Box>
                                )}
                        </Box>
                        </SubCard>
                    </Box>
            );
        });

    const handleClickOpenDelete = (data) => {
        setOpenDelete(true);
    };

    const handleClickOpenFolder = () => {
        setOpenFolder(true);
        setOpenUpdate(false);
        // fetchImages(); // REMOVED: S3 specific functionality
    };

    const handleUpdateClose = () => {
        setOpenUpdate(false);
    };

    const handleDeleteClose = () => {
        setOpenDelete(false);
        setOpenUpdate(false);
    };

    const handleUpdateSubmit = () => {
        // console.log(FolderName);
    };

    // UPDATED: Remove S3 SDK usage for fetching folders
    const fetchFolders = (project) => {
        // Folders are now managed through the backend API
        // This function is kept for compatibility but simplified
        setLoading(false);

        // The folder structure is now handled by the backend
        // When we fetch files via fetchUploadedFiles, the backend returns both files and folders
        setFolders([]);

        /* OLD S3 Implementation
        const params = {
            Bucket: 'datahub.n2nai.io',
            Prefix: localStorage.getItem('user_token') + '/' + project + '/',
            Delimiter: '/'
        };
        // console.log(params);
        setLoading(true);
        s3.listObjectsV2(params, async (err, data) => {
            if (err) {
                console.log(err);
            } else {
                // console.log(data)
                setSubObjects(data);
                // setFolders([])
                let Folders = [];
                data?.CommonPrefixes?.map((data, index) => {
                    // console.log(data)
                    if (data.Prefix.split(localStorage.getItem('user_token') + '/' + project + '/')[1] !== '') {
                        Folders.push(data.Prefix.split(localStorage.getItem('user_token') + '/' + project + '/')[1]);
                    }
                });

                let foldersWithData = Folders.map((f, i) => {
                    // console.log(projectsState.projects.filter((project) => `${project.project_name}/` === f)[0]);
                    // console.log(projectsState.projects)
                    const mappedProject = projectsState.projects.filter((project) => `${project.project_name}/` === f)[0];

                    return {
                        id: i + 1,
                        name: f,
                        project_desc: mappedProject !== undefined ? mappedProject.project_desc : '',
                        url_num: mappedProject !== undefined ? mappedProject.project_sitemap_num : '',
                        word_indexed: mappedProject !== undefined ? mappedProject.project_word_indexed : '',
                        query_num: mappedProject !== undefined ? mappedProject.project_query_month : '',
                        upload_num: mappedProject !== undefined ? mappedProject.project_document_num : '',
                        created_date: mappedProject !== undefined ? mappedProject.created_date : ''
                        // created_by: '2023-11-30'
                    };
                });

                // setObjects(foldersWithData);
            }
        });
        setLoading(false);
        setOpenFolder(true);
        */
    };

    // UPDATED: Remove S3 SDK usage, now using backend API for file listing
    const fetchFiles = (project, folder, screen) => {
        // The files are already fetched via fetchUploadedFiles Redux action
        // Just update the UI states based on the screen parameter

        setLoading(false);
        setOpenFolder(true);

        if (screen === 'DETAIL') {
            setShowUploadFile(true);
            setLoadingFileUpload(false);
        } else if (screen === 'SETTING') {
            setShowUploadFile(false);
            setOpenSetting(true);
        } else if (screen === 'SETTING INSIDE') {
            // Handle setting inside if needed
        }
    };

    // OLD S3 implementation - kept for reference
    /* const fetchFiles_OLD_S3 = (project, folder, screen) => {
        const params = {
            Bucket: 'datahub.n2nai.io',
            Prefix: localStorage.getItem('user_token') + '/' + project + '/' + folder,
            Delimiter: '/'
        };

        setLoading(true);

        s3.listObjectsV2(params, async (err, data) => {
            if (err) {
                console.log(err);
            } else {
                let Files = [];
                let rows = [];
                data?.Contents?.map((data, index) => {
                    if (data.Key.split(localStorage.getItem('user_token') + '/' + project + '/' + folder)[1] !== '') {
                        const name = data.Key.split(localStorage.getItem('user_token') + '/' + project + '/' + folder)[1];
                        Files.push(name);
                        const mappedUploadedFile = uploadedFilesState.uploadedFile.filter((file) => file.name === name)[0];
                        if (mappedUploadedFile === undefined) {
                            rows.push({
                                id: index,
                                name: name,
                                type: name.split('.')[name.split('.').length - 1],
                                crawl_status: 'Unknown',
                                index_status: 'Unknown',
                                word_num: 'Unknown',
                                created_date: moment(data['LastModified']).tz('Asia/Ho_Chi_Minh').format('DD/MM/YYYY HH:mm:ss'),
                                size: String(parseFloat(data['Size'] / 1024 / 1024).toFixed(2)) + ' MB'
                            });
                        } else {
                            rows.push({
                                id: index,
                                name: name,
                                type: name.split('.')[name.split('.').length - 1],
                                crawl_status: mappedUploadedFile.crawl_status,
                                index_status: mappedUploadedFile.index_status,
                                word_num: mappedUploadedFile.word_num,
                                created_date: moment(data['LastModified']).tz('Asia/Ho_Chi_Minh').format('DD/MM/YYYY HH:mm:ss'),
                                size: String(parseFloat(data['Size'] / 1024 / 1024).toFixed(2)) + ' MB'
                            });
                        }
                    }
                });
                // setRows(rows);
                setLoading(false);
                setOpenFolder(true);
                if (screen === 'DETAIL') {
                    setShowUploadFile(true);
                    setLoadingFileUpload(false);
                    // setShowPage(true);
                    // setLoadingTableMongoDB(false);
                } else if (screen === 'SETTING') {
                    setShowUploadFile(false);
                    setOpenSetting(true);
                } else if (screen === 'SETTING INSIDE') {
                }
            }
        });
    }; */

    useEffect(() => {
        if (FolderName != '' && isLoadingFileUpload && uploadedFilesState.uploadedFile !== null) {
            fetchFiles(project, FolderName, 'DETAIL');
        }
    }, [isLoadingFileUpload, FolderName, uploadedFilesState]);

    useEffect(() => {
        if (FolderName != '' && openSetting && uploadedFilesState.uploadedFile !== null) {
            fetchFiles(project, FolderName, 'SETTING');
        }
    }, [openSetting, FolderName, uploadedFilesState]);

    // REMOVED: fetchImages function - S3 specific functionality
    /* const fetchImages = () => {
        const params = {
            Bucket: 'kmou-dp',
            Prefix: 'Marine-Parts/' + project + '/' + FolderName,
            Delimiter: ''
        };

        // setLoading(true);

        s3.listObjectsV2(params, async (err, data) => {
            if (err) {
                console.log(err);
            } else {
                await new Promise((resolve) => {
                    let Images = [];
                    data.Contents.map(async (data, index) => {
                        if (data.Key.split('Marine-Parts/' + project + '/' + FolderName)[1] !== '') {
                            const params = {
                                Bucket: 'kmou-dp',
                                Key: data.Key
                            };

                            await s3.getSignedUrlPromise('getObject', params, (err, data) => {
                                if (err) {
                                    console.log(err);
                                } else {
                                    Images.push(data);
                                }
                            });
                        }
                    });

                    resolve(Images);
                }).then((Images) => {
                    setImages(Images);
                    // console.log(Images);
                });
                // setLoading(false)
            }
        });
    };

    async function onAddProjectClick() {
        const rawName = FolderName?.trim() || '';
        if (rawName === '') {
            alert('Vui lòng điền tên dự án');
            return;
        }

        const projectName = removeAccents(rawName);
        setOpenAddProject(false);

        try {
            await dispatch(addProjects(projectName, FolderDesc || '', tenantAdminEmail, tenantAdminPassword));
            await dispatch(createProjectJupyterhub(projectName));
            await dispatch(fetchProjects());

            dispatch(
                openSnackbar({
                    open: true,
                    anchorOrigin: { vertical: 'top', horizontal: 'center' },
                    message: 'Một dự án đã được thêm mới',
                    variant: 'alert',
                    alert: { color: 'success' }
                })
            );
        } catch (error) {
            dispatch(
                openSnackbar({
                    open: true,
                    anchorOrigin: { vertical: 'top', horizontal: 'center' },
                    message: 'Tạo dự án thất bại',
                    variant: 'alert',
                    alert: { color: 'error' }
                })
            );
        } finally {
            setFolderName('');
        }
    }
            
    /* OLD S3 Implementation - kept for reference
    let params = {
        Bucket: 'datahub.n2nai.io',
        Prefix: localStorage.getItem('user_token') + '/' + project + '/' + FolderName.replace('/', '')
    };

    s3.listObjects(params, function (err, data) {
        if (err) return console.log(err);

        if (data.Contents.length == 0) {
            s3.deleteObjects(params, function (err, data) {
                if (err) return console.log(err);
                else {
                    console.log('Delete Success');
                    fetchFolders(project);
                    dispatch(fetchProjects());
                }
            });
        } else {
            data.Contents.forEach(function (content) {
                params = { Bucket: 'datahub.n2nai.io' };
                params.Delete = { Objects: [] };
                params.Delete.Objects.push({ Key: content.Key });
            });

            s3.deleteObjects(params, function (err, data) {
                if (err) return console.log(err);
                else {
                    console.log('Delete Success');
                    fetchFolders(project);
                    dispatch(fetchProjects());
                }
            });
        }
    });
    */

    const timeRangeLabel = options.filter((items) => items.value.toString() === filter.range.toString());
    const timeSortLabel = sortOptions.filter((items) => items.value.toString() === filter.sort.toString());

    const applyDateFilter = (days) => {
        let filteredProjects;
        if (days !== 9999) {
            const currentDate = new Date();
            const daysAgo = new Date(currentDate);
            daysAgo.setDate(currentDate.getDate() - days);

            filteredProjects = Objects.filter((project) => {
                const projectDate = new Date(moment(project.created_date, "'DD/MM/YYYY hh:mm:ss'"));
                return projectDate >= daysAgo && projectDate <= currentDate;
            });
        } else {
            filteredProjects = projectsState?.projects;
        }
        // Kiểm tra và sắp xếp theo chiều hướng
        if (filter.sort === 'asc') {
            filteredProjects.sort((a, b) => {
                const dateA = new Date(moment(a.created_date, "'DD/MM/YYYY hh:mm:ss'"));
                const dateB = new Date(moment(b.created_date, "'DD/MM/YYYY hh:mm:ss'"));
                return dateA - dateB; // Sắp xếp tăng dần (cũ nhất đến mới nhất)
            });
        } else if (filter.sort === 'desc') {
            filteredProjects.sort((a, b) => {
                const dateA = new Date(moment(a.created_date, "'DD/MM/YYYY hh:mm:ss'"));
                const dateB = new Date(moment(b.created_date, "'DD/MM/YYYY hh:mm:ss'"));
                return dateB - dateA; // Sắp xếp giảm dần (mới nhất đến cũ nhất)
            });
        }
        setObjects(filteredProjects);
    };

    const handleMenuItemClick = (event, index) => {
        setFilter({ ...filter, range: index });
        setanchorElTimeRange(null);

        switch (index) {
            case 'all':
                applyDateFilter(9999);
                break;
            case '7':
                applyDateFilter(7);
                break;
            case '30':
                applyDateFilter(30);
                break;
            case '90':
                applyDateFilter(90);
                break;
            default:
                break;
        }
    };

    const handleCopyLink = () => {
        const link = `https://datahub.n2nai.io/pages/bot?id=${String(vector)}&project=${FolderName.replaceAll('/', '')}`;
        navigator.clipboard.writeText(link).then(() => {
            setCopy(true);
            setTimeout(() => {
                setCopy(false);
            }, 2000); // 2000 milliseconds = 2 seconds
        });
    };

    const handleCopyApi = () => {
        navigator.clipboard.writeText(apiKeys[0]?.api_key).then(() => {
            setCopyAPI(true);
            setTimeout(() => {
                setCopyAPI(false);
            }, 2000); // 2000 milliseconds = 2 seconds
        });
    };

    const handleCopyMongoDBUri = () => {
        navigator.clipboard.writeText(mongoDBUri).then(() => {
            setCopyMongoDBUri(true);
            setTimeout(() => {
                setCopyMongoDBUri(false);
            }, 2000); // 2000 milliseconds = 2 seconds
        });
    };

    const handleCopyJupyterHubUser = () => {
        navigator.clipboard.writeText(jupyterHubUser).then(() => {
            setCopyJupyterHubUser(true);
            setTimeout(() => {
                setCopyJupyterHubUser(false);
            }, 2000); // 2000 milliseconds = 2 seconds
        });
    };

    const handleCopyJupyterHubPasswd = () => {
        navigator.clipboard.writeText(jupyterHubPasswd || '').then(() => {
            setCopyJupyterHubPasswd(true);
            setTimeout(() => {
                setCopyJupyterHubPasswd(false);
            }, 2000); // 2000 milliseconds = 2 seconds
        });
    };

    const handleCopyJupyterHubLink = () => {
        navigator.clipboard.writeText(jupyterHubLink).then(() => {
            setCopyJupyterHubLink(true);
            setTimeout(() => {
                setCopyJupyterHubLink(false);
            }, 2000); // 2000 milliseconds = 2 seconds
        });
    };

    const handleCopyAirflowUser = () => {
        navigator.clipboard.writeText(airflowUser).then(() => {
            setCopyAirflowUser(true);
            setTimeout(() => {
                setCopyAirflowUser(false);
            }, 2000); // 2000 milliseconds = 2 seconds
        });
    };

    const handleCopyAirflowPasswd = () => {
        navigator.clipboard.writeText(airflowPasswd).then(() => {
            setCopyAirflowPasswd(true);
            setTimeout(() => {
                setCopyAirflowPasswd(false);
            }, 2000); // 2000 milliseconds = 2 seconds
        });
    };

    const handleCopyAirflowLink = () => {
        navigator.clipboard.writeText(airflowLink).then(() => {
            setCopyAirflowLink(true);
            setTimeout(() => {
                setCopyAirflowLink(false);
            }, 2000); // 2000 milliseconds = 2 seconds
        });
    };

    // ANCHOR handlers

    // const handleRefetch = () => /* refetch */

    // const fileAction = ({ action; data: any; method?: "POST" | "PATCH" | "DELETE" }) => /* file action */

    // const folderAction = ({ action: string; data: any; method?: "POST" | "PATCH" | "DELETE" }) => /* file action */

    // const onSelectFile = (file: {id: "number", full_path: "string", name_without_prefix: 'string', mime_type: "string"}) => /* handle select file */

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, py: 0, px: { xs: 1, sm: 2 } }}>
            <Box sx={{ width: '100%' }}>
                {!isShowUploadFile && !openSetting && !initialProjectsState && (
                    <MainCard
                        title={
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Typography variant="h3">Dự án & Kho lưu trữ</Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        gap: 2,
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    {canCreateProjectRole && (
                                        <Button
                                            disabled={buttonCreateProjectDisabled}
                                            variant="contained"
                                            onClick={() => setOpenAddProject(true)}
                                            sx={{ backgroundColor: '#156DA2' }}
                                        >
                                            Tạo dự án
                                        </Button>
                                    )}
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            alignItems: 'center',
                                            gap: 1,
                                            justifyContent: 'flex-end',
                                            flex: { xs: '1 1 100%', sm: '0 0 auto' }
                                        }}
                                    >
                                                <Button
                                                    id="filter-time-range-button"
                                                    aria-controls="filter-time-range-menu"
                                                    aria-haspopup="true"
                                                    disableElevation
                                                    aria-expanded={openSortTimeRange ? 'true' : undefined}
                                                    onClick={handleClickListTimeRangeItem}
                                                    sx={{
                                                        color: 'grey.500',
                                                        fontWeight: 400,
                                                        border: '1px solid #ccc',
                                                        marginRight: 1,
                                                        padding: '8px',
                                                        paddingX: '20px',
                                                        borderRadius: '8px'
                                                    }}
                                                    endIcon={<FilterList />}
                                                >
                                                    {timeRangeLabel.length > 0 && timeRangeLabel[0].label}
                                                </Button>
                                                <Menu
                                                    id="filter-time-range-menu"
                                                    aria-labelledby="filter-time-range-button"
                                                    anchorEl={anchorElTimeRange}
                                                    open={openSortTimeRange}
                                                    onClose={handleCloseTimeRange}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'right'
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'right'
                                                    }}
                                                >
                                                    {options.map((option, index) => (
                                                        <MenuItem
                                                            sx={{ p: 1.5 }}
                                                            key={index}
                                                            selected={option.value === filter.sort}
                                                            onClick={(event) => handleMenuItemClick(event, option.value)}
                                                        >
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Menu>

                                                <Button
                                                    id="filter-time-sort-button"
                                                    aria-controls="filter-time-sort-menu"
                                                    aria-haspopup="true"
                                                    aria-expanded={openSortTimeSort ? 'true' : undefined}
                                                    onClick={handleClickListTimeSortItem}
                                                    sx={{
                                                        color: 'grey.500',
                                                        fontWeight: 400,
                                                        border: '1px solid #ccc',
                                                        marginRight: 1,
                                                        padding: '8px',
                                                        paddingX: '20px',
                                                        borderRadius: '8px'
                                                    }}
                                                    endIcon={<KeyboardArrowDownIcon />}
                                                >
                                                    {timeSortLabel.length > 0 && timeSortLabel[0].label}
                                                </Button>
                                                <Menu
                                                    id="filter-time-sort-menu"
                                                    aria-labelledby="filter-time-sort-button"
                                                    anchorEl={anchorElTimeSort}
                                                    open={openSortTimeSort}
                                                    onClose={handleCloseTimeSort}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'right'
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'right'
                                                    }}
                                                >
                                                    {sortOptions.map((option, index) => (
                                                        <MenuItem
                                                            sx={{ p: 1.5 }}
                                                            key={index}
                                                            // selected={option.value === filter.sort}
                                                            onClick={(event) => handleMenuTimeSortItemClick(event, option.value)}
                                                        >
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Menu>
                                        <TextField
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon fontSize="small" />
                                                    </InputAdornment>
                                                )
                                            }}
                                            onChange={handleSearch}
                                            placeholder="Tìm kiếm"
                                            value={search}
                                            size="small"
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        }
                        sx={{ marginTop: 0, paddingTop: 0 }}
                    >
                        {renderProjectList(Objects)}
                    </MainCard>
                )}
                {isShowUploadFile && !isLoadingFileUpload && (
                    <TableUploadFile
                        onClick={() => {
                            setShowUploadFile(false);
                            dispatch(removeUploadedFiles());
                            dispatch(fetchProjects());
                            setFolderName('');
                        }}
                        folderName={FolderName.replace('/', '')}
                        projectSubname={projectSubname}
                        // dataUploadFile={rows}
                        dataUploadFile={uploadedFilesState.uploadedFile}
                        isSetting={false}
                    />
                )}
                {/* All modules now use separate routes:
                    - MongoDB: /workspace/storage/:projectId/mongodb
                    - Airflow: /workspace/storage/:projectId/airflow
                    - API Gateway: /workspace/storage/:projectId/api-gateway
                    - CV: /workspace/storage/:projectId/cv
                */}
            </Box>
            {/* All Dialog is defined here */}
            <Dialog open={openUpdate} onClose={handleUpdateClose} aria-labelledby="form-dialog-title">
                {openUpdate && (
                    <>
                        <DialogTitle id="form-dialog-title">Update Folder</DialogTitle>
                        <DialogContent>
                            <Stack spacing={3}>
                                <DialogContentText>
                                    <Typography variant="body2" component="span">
                                        Folder Name
                                    </Typography>
                                </DialogContentText>
                                <TextField
                                    disabled={!isRename}
                                    value={FolderName}
                                    onChange={(e) => {
                                        setFolderName(e.target.value);
                                    }}
                                    autoFocus
                                    size="small"
                                    id="fileName"
                                    name="fileName"
                                    label="Folder Name"
                                    fullWidth
                                />
                            </Stack>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button
                                sx={{ color: theme.palette.primary.light }}
                                variant="contained"
                                size="small"
                                onClick={handleClickOpenFolder}
                            >
                                Open Folder
                            </Button>
                            {!isRename && (
                                <Button
                                    sx={{ color: theme.palette.info.dark }}
                                    variant="outlined"
                                    size="small"
                                    onClick={() => {
                                        setRename(true);
                                    }}
                                >
                                    Rename Folder
                                </Button>
                            )}
                            {isRename && (
                                <Button variant="contained" size="small" onClick={handleUpdateSubmit}>
                                    Submit
                                </Button>
                            )}
                            <Button
                                sx={{ color: theme.palette.error.dark }}
                                variant="outlined"
                                size="small"
                                onClick={handleClickOpenDelete}
                            >
                                Delete
                            </Button>
                            <Button sx={{ color: theme.palette.secondary.dark }} onClick={handleUpdateClose} color="secondary">
                                Cancel
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            <Dialog
                open={openImage}
                onClose={() => {
                    setOpenImage(false);
                }}
                aria-labelledby="form-dialog-title"
            >
                {openImage && (
                    <>
                        <DialogTitle id="form-dialog-title">Image</DialogTitle>
                        <DialogContent>
                            <Stack spacing={3}>
                                <DialogContentText>
                                    <Typography variant="body2" component="span">
                                        <Button variant="text">{Image.split('/')[Image.split('/').length - 1].split('?')[0]}</Button>
                                    </Typography>
                                </DialogContentText>
                                <img alt={Image} src={Image}></img>
                            </Stack>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button
                                sx={{ color: theme.palette.error.dark }}
                                onClick={() => {
                                    setOpenImage(false);
                                }}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            <Dialog
                open={isOpenAddProject}
                fullWidth
                onClose={() => {
                    setOpenAddProject(false);
                    setNameProjectExists(false);
                    setFolderName('');
                    setTenantAdminEmail('');
                    setTenantAdminPassword('');
                }}
                aria-labelledby="form-dialog-title"
            >
                {isOpenAddProject && (
                    <>
                        <DialogTitle id="form-dialog-title">Tạo mới dự án</DialogTitle>
                        <DialogContent>
                            <form onSubmit={(e) => e.preventDefault()} style={{ width: '100%' }}>
                            <Stack spacing={3}>
                                <DialogContentText></DialogContentText>
                                <TextField
                                    value={FolderName}
                                    error={isNameProjectExists}
                                    onChange={(e) => {
                                        setFolderName(e.target.value);
                                        if (isNameProjectExists) setNameProjectExists(false);
                                    }}
                                    autoFocus
                                    size="small"
                                    id="fileName"
                                    name="fileName"
                                    label="Tên dự án"
                                    fullWidth
                                    required
                                    helperText={isNameProjectExists ? 'Tên dự án đã tồn tại, vui lòng nhập tên khác.' : null}
                                />
                                <TextField
                                    onChange={(e) => {
                                        setFolderDesc(e.target.value);
                                    }}
                                    size="small"
                                    id="fileDesc"
                                    name="fileDesc"
                                    label="Mô tả dự án"
                                    fullWidth
                                />
                                {isSuperadminRole && (
                                    <>
                                        <TextField
                                            value={tenantAdminEmail}
                                            onChange={(e) => setTenantAdminEmail(e.target.value)}
                                            size="small"
                                            id="tenantAdminEmail"
                                            name="tenantAdminEmail"
                                            label="Email đăng nhập tenant (bắt buộc)"
                                            placeholder="user@example.com"
                                            fullWidth
                                            type="email"
                                            required
                                        />
                                        <TextField
                                            value={tenantAdminPassword}
                                            onChange={(e) => setTenantAdminPassword(e.target.value)}
                                            size="small"
                                            id="tenantAdminPassword"
                                            name="tenantAdminPassword"
                                            label="Mật khẩu đăng nhập tenant (bắt buộc)"
                                            placeholder="Mật khẩu đăng nhập"
                                            fullWidth
                                            type="password"
                                            required
                                            helperText="Tài khoản này sẽ được dùng để đăng nhập DataHub."
                                        />
                                    </>
                                )}
                            </Stack>
                            </form>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button
                                variant="outlined"
                                // sx={{ color: theme.palette.error.dark, padding: '6px 16px' }}
                                onClick={() => {
                                    setOpenAddProject(false);
                                    setNameProjectExists(false);
                                    setFolderName('');
                                    setTenantAdminEmail('');
                                    setTenantAdminPassword('');
                                }}
                                size="small"
                                color="secondary"
                            >
                                Thoát
                            </Button>
                            <Button
                                disabled={
                                    FolderName === '' ||
                                    (isSuperadminRole &&
                                        (!tenantAdminEmail?.trim() || !tenantAdminPassword?.trim()))
                                }
                                variant="contained"
                                sx={{ backgroundColor: '#156DA2' }}
                                size="small"
                                onClick={async () => {
                                    const rawName = FolderName?.trim() || '';
                                    if (rawName === '') {
                                        alert('Vui lòng điền tên dự án');
                                        return;
                                    }
                                    const projectName = removeAccents(rawName);
                                    const normalized = projectName.toLowerCase();
                                    const exists = Array.isArray(Objects) && Objects.some(
                                        (object) => (object.project_name || '').trim().toLowerCase() === normalized
                                    );
                                    if (exists) {
                                        setNameProjectExists(true);
                                        dispatch(
                                            openSnackbar({
                                                open: true,
                                                anchorOrigin: { vertical: 'top', horizontal: 'center' },
                                                message: 'Tên dự án đã tồn tại, vui lòng nhập tên khác.',
                                                variant: 'alert',
                                                alert: { color: 'error' }
                                            })
                                        );
                                        return;
                                    }
                                    const email = tenantAdminEmail;
                                    const password = tenantAdminPassword;
                                    try {
                                        await dispatch(addProjects(projectName, FolderDesc || '', email, password));
                                        await dispatch(createProjectJupyterhub(projectName));
                                        await dispatch(fetchProjects());
                                        dispatch(
                                            openSnackbar({
                                                open: true,
                                                anchorOrigin: { vertical: 'top', horizontal: 'center' },
                                                message: 'Một dự án đã được thêm mới',
                                                variant: 'alert',
                                                alert: { color: 'success' }
                                            })
                                        );
                                        setOpenAddProject(false);
                                        setFolderName('');
                                        setTenantAdminEmail('');
                                        setTenantAdminPassword('');
                                    } catch (error) {
                                        dispatch(
                                            openSnackbar({
                                                open: true,
                                                anchorOrigin: { vertical: 'top', horizontal: 'center' },
                                                message: error?.data?.detail || 'Tạo dự án thất bại',
                                                variant: 'alert',
                                                alert: { color: 'error' }
                                            })
                                        );
                                    } finally {
                                        setFolderName('');
                                    }
                                }}
                            >
                                Tạo mới
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            <Dialog
                open={isOpenMongoDBInfo}
                fullWidth
                onClose={() => {
                    setOpenMongoDBInfo(false);
                }}
                aria-labelledby="form-dialog-title"
            >
                {isOpenMongoDBInfo && (
                    <>
                        <DialogTitle id="form-dialog-title">Thông tin MongoDB URI</DialogTitle>
                        <DialogContent>
                            <Box sx={{ flexGrow: 1 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Chia sẻ API"
                                            id="bot"
                                            name="bot"
                                            disabled
                                            value={mongoDBUri.replace(mongoDBUri.substring(10, 500), '**********************')}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="button-copy-content"
                                                            onClick={handleCopyMongoDBUri}
                                                            edge="end"
                                                            sx={{ marginRight: '0.5px' }}
                                                        >
                                                            <Tooltip title={isCopyMongoDBUri === false ? 'Copy MongoDB URL' : 'Copied'}>
                                                                <ContentCopyTwoToneIcon fontSize="small" />
                                                            </Tooltip>
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{ m: 2, width: '90%' }}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    setOpenMongoDBInfo(false);
                                }}
                                size="small"
                                color="secondary"
                            >
                                Thoát
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            <Dialog
                open={isOpenJupyterHubInfo}
                fullWidth
                onClose={() => {
                    setOpenJupyterHubInfo(false);
                }}
                aria-labelledby="form-dialog-title"
            >
                {isOpenJupyterHubInfo && (
                    <>
                        <DialogTitle id="form-dialog-title">Thông tin Jupyter Hub</DialogTitle>
                        <DialogContent>
                            <Box sx={{ flexGrow: 1 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Jupyter Hub Url"
                                            id="bot"
                                            name="bot"
                                            disabled
                                            value={jupyterHubLink}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="button-copy-content"
                                                            onClick={handleCopyJupyterHubLink}
                                                            edge="end"
                                                            sx={{ marginRight: '0.5px' }}
                                                        >
                                                            <Tooltip
                                                                title={isCopyJupyterHubLink === false ? 'Copy Jupyter Hub Link' : 'Copied'}
                                                            >
                                                                <ContentCopyTwoToneIcon fontSize="small" />
                                                            </Tooltip>
                                                        </IconButton>
                                                        <IconButton
                                                            aria-label="button-copy-content"
                                                            onClick={(e) => {}}
                                                            edge="end"
                                                            href={jupyterHubLink}
                                                            target="_blank"
                                                        >
                                                            <Tooltip title="Mở link trong tab mới">
                                                                <InsertLinkTwoTone fontSize="small" />
                                                            </Tooltip>
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{ m: 2, width: '90%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Jupyter Hub Username"
                                            id="bot"
                                            name="bot"
                                            disabled
                                            value={jupyterHubUser.replace(jupyterHubUser.substring(0, 500), '**********************')}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="button-copy-content"
                                                            onClick={handleCopyJupyterHubUser}
                                                            edge="end"
                                                            sx={{ marginRight: '0.5px' }}
                                                        >
                                                            <Tooltip
                                                                title={isCopyJupyterHubUser === false ? 'Copy Jupyter Hub User' : 'Copied'}
                                                            >
                                                                <ContentCopyTwoToneIcon fontSize="small" />
                                                            </Tooltip>
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{ m: 2, width: '90%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Jupyter Hub Password"
                                            id="bot"
                                            name="bot"
                                            disabled
                                            value={
                                                jupyterHubPasswd
                                                    ? jupyterHubPasswd.replace(jupyterHubPasswd.substring(0, 500), '**********************')
                                                    : ''
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="button-copy-content"
                                                            onClick={handleCopyJupyterHubPasswd}
                                                            edge="end"
                                                            sx={{ marginRight: '0.5px' }}
                                                        >
                                                            <Tooltip
                                                                title={
                                                                    isCopyJupyterHubPasswd === false
                                                                        ? 'Copy Jupyter Hub Password'
                                                                        : 'Copied'
                                                                }
                                                            >
                                                                <ContentCopyTwoToneIcon fontSize="small" />
                                                            </Tooltip>
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{ m: 2, width: '90%' }}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button
                                variant="outlined"
                                // sx={{ color: theme.palette.error.dark, padding: '6px 16px' }}
                                onClick={() => {
                                    setOpenJupyterHubInfo(false);
                                }}
                                size="small"
                                color="secondary"
                            >
                                Thoát
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            <Dialog
                open={isOpenAirflowInfo}
                fullWidth
                onClose={() => {
                    setOpenAirflowInfo(false);
                }}
                aria-labelledby="form-dialog-title"
            >
                {isOpenAirflowInfo && (
                    <>
                        <DialogTitle id="form-dialog-title">Thông tin Apache Airflow</DialogTitle>
                        <DialogContent>
                            <Box sx={{ flexGrow: 1 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Apache Airflow Url"
                                            id="bot"
                                            name="bot"
                                            disabled
                                            value={airflowLink}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="button-copy-content"
                                                            onClick={handleCopyAirflowLink}
                                                            edge="end"
                                                            sx={{ marginRight: '0.5px' }}
                                                        >
                                                            <Tooltip title={isCopyAirflowLink === false ? 'Copy Airflow Link' : 'Copied'}>
                                                                <ContentCopyTwoToneIcon fontSize="small" />
                                                            </Tooltip>
                                                        </IconButton>
                                                        <IconButton
                                                            aria-label="button-copy-content"
                                                            onClick={(e) => {}}
                                                            edge="end"
                                                            href={airflowLink}
                                                            target="_blank"
                                                        >
                                                            <Tooltip title="Mở link trong tab mới">
                                                                <InsertLinkTwoTone fontSize="small" />
                                                            </Tooltip>
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{ m: 2, width: '90%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Airflow Username"
                                            id="bot"
                                            name="bot"
                                            disabled
                                            value={airflowUser.replace(airflowUser.substring(0, 500), '**********************')}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="button-copy-content"
                                                            onClick={handleCopyAirflowUser}
                                                            edge="end"
                                                            sx={{ marginRight: '0.5px' }}
                                                        >
                                                            <Tooltip title={isCopyAirflowUser === false ? 'Copy Airflow User' : 'Copied'}>
                                                                <ContentCopyTwoToneIcon fontSize="small" />
                                                            </Tooltip>
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{ m: 2, width: '90%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Apache Airflow Password"
                                            id="bot"
                                            name="bot"
                                            disabled
                                            value={airflowPasswd.replace(airflowPasswd.substring(0, 500), '**********************')}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="button-copy-content"
                                                            onClick={handleCopyAirflowPasswd}
                                                            edge="end"
                                                            sx={{ marginRight: '0.5px' }}
                                                        >
                                                            <Tooltip
                                                                title={isCopyAirflowPasswd === false ? 'Copy Airflow Password' : 'Copied'}
                                                            >
                                                                <ContentCopyTwoToneIcon fontSize="small" />
                                                            </Tooltip>
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{ m: 2, width: '90%' }}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button
                                variant="outlined"
                                // sx={{ color: theme.palette.error.dark, padding: '6px 16px' }}
                                onClick={() => {
                                    setOpenAirflowInfo(false);
                                }}
                                size="small"
                                color="secondary"
                            >
                                Thoát
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            {/* Dialog Delete Project */}
            <Dialog
                open={openDelete}
                // fullWidth
                onClose={() => {
                    handleDeleteClose();
                }}
                aria-labelledby="form-dialog-delete"
            >
                {openDelete && (
                    <>
                        <DialogTitle align="center" id="form-dialog-delete">
                            Xóa dự án {FolderName.replaceAll('/', '')} ?
                        </DialogTitle>
                        <DialogContent>
                            <Stack spacing={3}>
                                <DialogContentText align="center">
                                    <Typography variant="body2" component="span">
                                        Những dữ liệu liên quan sẽ bị xóa
                                    </Typography>
                                </DialogContentText>
                            </Stack>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => {
                                    setOpenDelete(false);
                                }}
                                color="secondary"
                            >
                                Hủy bỏ
                            </Button>
                            <Button
                                variant="contained"
                                sx={{ backgroundColor: '#156DA2' }}
                                size="small"
                                onClick={(e) => {
                                    handleDeleteClick(FolderName);
                                }}
                            >
                                Xác nhận
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            {/* Dialog Upload Files */}
            {FolderName !== '' && (
                <Upload
                    projectName={FolderName.replace('/', '')}
                    projectSubname={projectSubname}
                    modalState={uploadModalState}
                    setModalState={setUploadModalState}
                    // fetchFiles={fetchFiles}
                    fetchUploadedFiles={() => {
                        dispatch(fetchUploadedFiles(FolderName.replace('/', '')));
                    }}
                ></Upload>
            )}
            {membersDialogProject && (
                <ProjectMembersDialog projectName={membersDialogProject} onClose={() => setMembersDialogProject(null)} />
            )}
        </Box>
    );
};

export default ProjectManagement;
